/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Likes_viewer = {
    readonly favoriteNotifications?: {
        readonly id: string;
        readonly hasNewEvents: boolean | null;
    } | null;
    readonly favoriteNotificationsTiles?: {
        readonly " $fragmentRefs": FragmentRefs<"FavNotifications_favoriteNotificationsTiles">;
    } | null;
    readonly " $refType": "Likes_viewer";
};
export type Likes_viewer$data = Likes_viewer;
export type Likes_viewer$key = {
    readonly " $data"?: Likes_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Likes_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v2 = {
  "kind": "Variable",
  "name": "eventsLimit",
  "variableName": "eventsLimit"
};
return {
  "kind": "Fragment",
  "name": "Likes_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNewEvents",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": 0
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNewEvents",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoriteNotifications",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNewEvents",
              "args": [
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNotifications",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "favoriteNotificationsTiles",
          "name": "favoriteNotifications",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "FavoriteNotifications",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FavNotifications_favoriteNotificationsTiles",
              "args": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "Variable",
                  "name": "notificationItemsLimit",
                  "variableName": "notificationItemsLimit"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f61435e6e8cad92af85cd8418309071f';
export default node;
